import {
  useEffect,
  useRef,
} from 'react';
import classNames from 'classnames';
import autosize from 'autosize';

import { InputLabel } from '@ui/InputLabel';
import { FormError } from '@ui/FormError';

// styles
import s from './TextArea.sss';

// types
type TextAreaProps = React.HTMLProps<HTMLTextAreaElement> & {
  invalid?: boolean
  label?: string
  error?: React.ReactNode
  helpText?: React.ReactNode
  withAutosize?: boolean
  inputClassName?: string
};

export const TextArea: React.FC<TextAreaProps> = ({
  withAutosize = false,
  className,
  invalid,
  label,
  error,
  helpText,
  required,
  inputClassName,
  ...props
}) => {
  const inputRef = useRef<HTMLTextAreaElement>(null);

  const hasError = Array.isArray(error) ? !!error.length : !!error;

  useEffect(
    () => {
      if (withAutosize) {
        autosize(inputRef.current!);
      }
    },
    [withAutosize],
  );

  return (
    <div
      className={classNames(
        s.root,
        { [s.invalid]: hasError || invalid },
        className,
      )}
    >
      {label
        && (
        <InputLabel
          className={s.label}
          required={required}
          onClick={() => inputRef.current!.focus()}
        >
          {label}
        </InputLabel>
        )}
      <textarea
        ref={inputRef}
        className={classNames(s.input, inputClassName)}
        {...props}
      />
      {helpText && <div className={s.helpText}>{helpText}</div>}
      {error && (
        Array.isArray(error)
          ? error.map((e, i) => <FormError key={i}>{e}</FormError>)
          : <FormError>{error}</FormError>
      )}
    </div>
  );
};
